import { PayloadAction, createSlice, createSelector } from '@reduxjs/toolkit'

import { RootState } from 'redux/store'

export enum Timer {
    SET_PAGE_FORCE_LIVE = 'set-page-force-live',
    SET_PAGE_END_PREVIEW = 'set-page-end-preview',
    SET_PAGE_START_TIME = 'set-page-start-time',
    SET_PAGE_OPEN_CURTAIN = 'set-page-open-curtain',
    SET_PAGE_CLOSE_CURTAIN = 'set-page-close-curtain',
    SET_PAGE_CLOSING_CURTAIN = 'set-page-closing-curtain',
    WORDFLOW_TIME_LEFT = 'wordflow-time-left',
}

export interface TimersState {
    list: { [t in Timer]: NodeJS.Timeout | null }
}

export const initialState = {
    list: {},
}

const timersSlice = createSlice({
    name: 'timers',
    initialState: initialState,
    reducers: {
        timerCreated: (state, { payload: timer }: PayloadAction<{ name: Timer; id: NodeJS.Timeout }>) => {
            state.list[timer.name] = timer.id
        },
        resetTimer: (state, { payload: timerName }: PayloadAction<Timer>) => {
            state.list[timerName] = null
        },
    },
})

const { actions, reducer } = timersSlice

export default reducer

export const { timerCreated, resetTimer } = actions

export const getTimersState = (store: RootState) => store.timers

export const getTimers = createSelector(getTimersState, timers => timers.list)

export const getTimer = (store: RootState, timerName: Timer): NodeJS.Timeout | null | undefined =>
    createSelector(getTimers, timers => timers[timerName])(store)
